import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserPipe } from "./user.pipe";
import { KeysPipe } from "./keys.pipe";
import { SafePipe } from "./safe.pipe";
import { SafeDatePipe } from './safe-date.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        UserPipe,
        KeysPipe,
        SafePipe,
        SafeDatePipe
	],
	exports:[
        UserPipe,
        KeysPipe,
        SafePipe,
        SafeDatePipe
	]
})
export class SharedPipesModule { }



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/pipes/shared-pipes.module.ts